module.exports = [{
      plugin: require('/opt/render/project/src/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"G-D00GMC02YL","anonymize":true},
    }]
